module.exports = __webpack_public_path__ + "static/media/company_networked_gnomes.38cf6211.svg";